import React, { useContext } from "react";
import {
    ArrowLeftStartOnRectangleIcon,
    MoonIcon,
    SunIcon,
    Bars3Icon,
} from "@heroicons/react/24/outline";
import { AuthContext } from "../../App";

export default function TopBar({ onToggleSidebar, theme, toggleTheme }) {
    const { logout } = useContext(AuthContext);

    return (
        <div className="fixed top-0 left-0 z-40 w-full h-14 bg-gray-900 text-white flex items-center justify-between px-4 shadow-md md:pl-72">
            {/* Left Section */}
            <div className="flex items-center gap-3">
                <button
                    onClick={onToggleSidebar}
                    className="md:hidden text-white hover:text-red-500"
                >
                    <Bars3Icon className="h-6 w-6" />
                </button>
            </div>

            {/* Right Section */}
            <div className="flex items-center gap-4">
                <button onClick={toggleTheme} className="hover:text-red-500">
                    {theme === "dark" ? (
                        <SunIcon className="h-5 w-5" />
                    ) : (
                        <MoonIcon className="h-5 w-5" />
                    )}
                </button>
                <button
                    onClick={logout}
                    className="flex items-center gap-1 hover:text-red-500 transition-colors"
                >
                    <ArrowLeftStartOnRectangleIcon className="h-5 w-5" />
                    <span className="hidden sm:inline">Logout</span>
                </button>
            </div>
        </div>
    );
}
